import React from 'react'
import Header from './Header'
import Footer from './Footer'

const TermsAndConditions = () => {
    return (
        <div className="app">
        <Header/>
        <div className="privacyPolicy">
            <h1>Terms and Conditions</h1>
            <br/><br/>
            <p>
               
<strong>Refund Policy</strong><br/><br/> 

 
The Customer has the right to file a complaint regarding matters related to the operation of the Website and the provision of services provided by the Seller.<br/> 

Complaints regarding payment transactions processed by the Payment Operator should be submitted directly to the Payment Operator. Complaints regarding the operation of the Website and purchased services should be submitted via email to the following address: spedytorszkolenia@gmail.com <br/> 

Complaints will be considered by the Seller immediately, but no later than within 14 days from the date the Seller receives the complaint. A response to the complaint will be sent to the User by return email.<br/> 

In the case of Customers who are not also Consumers, the warranty is excluded. The Seller does not provide a warranty for services provided on the Website.<br/> 

Pursuant to Art. Pursuant to Article 38, Section 13 of the Act of 30 May 2014 on Consumer Rights, the right to withdraw from a distance contract does not apply to the Consumer in the case of a contract for the supply of digital content that is not recorded on a tangible medium, if the performance of the contract began with the Consumer's express consent before the expiry of the withdrawal period and after informing them of the loss of this right.<br/> 

By using the purchased online course (by opening it, starting its playback, or downloading materials), the Consumer consents to the immediate commencement of the performance and acknowledges that they lose the right to withdraw from the contract. 

<br/><br/> 

<strong>Privacy Policy</strong><br/><br/> 

 

 

<strong>PRIVACY AND COOKIE USE POLICY</strong><br/><br/> 

  

Protecting the privacy of our website visitors is our top priority. Therefore, we strive to secure the personal data of our website visitors. This privacy policy clearly explains and presents the principles and scope of personal data processing. It also includes the procedure for using cookies. State-of-the-art organizational and technical measures are used to ensure a high level of protection for personal data processing. This privacy policy is addressed to all users of the website spedytorszkolenia.pl It is effective from June 17, 2025. 
<br/><br/> 

 

<strong>DEFINITIONS:</strong><br/><br/> 

  

1. Controller – an entity that independently determines the purposes and means of processing personal data. The controller of personal data is Krzysztof Wiśniewski, ul. Derdowskiego 9/17, 85-795 Bydgoszcz, NIP 5541012980. 

 <br/> 

2. Personal Data – information about an identified or identifiable natural person. 

 <br/> 

3. Website: https://spedytorszkolenia.pl 

 <br/> 

4. Processor – an entity that processes data on behalf of the controller. 

 <br/> 

5. GDPR – Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC.<br/> 

  

6. Recipient or User – individuals visiting the website. 

 <br/> 

7. Policy – this privacy policy, effective from June 17, 2025. 

 <br/> 

8. Cookies – IT data and text files stored on users' devices (e.g. computer, laptop, smartphone, tablet or phone) sent via websites. 

<br/><br/> 

 
<strong>WHO IS THE PERSONAL DATA CONTROLLER AND HOW CAN I CONTACT HIM?</strong><br/><br/> 

  

The Personal Data Controller of all website users, within the meaning of the Regulation (EU) of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (GDPR), is Krzysztof Wiśniewski, ul. Derdowskiego 9/17, 85-795 Bydgoszcz, NIP 5541012980. For matters concerning the processing of personal data, you can contact the Personal Data <br/>Controller by email: spedytorszkolenia@gmail.com 

<br/><br/> 
<strong>HOW DO WE COLLECT YOUR PERSONAL DATA AND WHAT TYPE OF YOUR DATA DO WE PROCESS?</strong><br/><br/> 

  

We received your personal data when you filled out the form on our website. The Controller processes your following personal data: 

 <br/> 

a) name and surname, email address, information contained in the content of messages sent via our website and via email, including communication content and metadata for the purpose of completing the contact form and contacting us, 

 <br/> 

b) name and surname, email address for the purpose of configuring subscriptions to our emails or newsletters, 

 <br/> 

c) in connection with the use of cookies, this will include: computer information (IP address, geographic location, browser type and version, operating system type), information about visits to and use of our website (referral source, length of visit, page views, and website navigation paths), as well as information generated during your use of our website (when, how often, and under what circumstances you use our website, 

 <br/> 

Additionally, we embed a Facebook, Instagram, and Tiktok widget that allows you to see the number of likes, shares, and recommendations, and also allows you to like, share, and recommend our websites. This widget may collect data such as: address IP address, browser type, and versions, as well as storing and retrieving cookies on the browser. Additional tracking and monitoring of interactions with the widget is embedded, including correlating accounts with any actions taken within the widget, such as liking, sharing, or recommending our website. For additional information on how this data is used, please review the privacy policies of individual portals, which can be found directly on their websites. 

<br/><br/> 
<strong>FOR WHAT PURPOSE DO WE PROCESS YOUR PERSONAL DATA? 

 </strong><br/><br/> 

Personal data submitted to us through our website will be used for the purposes specified in this policy or on the relevant pages of the website. Your personal data may be used for the following purposes: 

 <br/> 

• Communicating with you. We use your personal data to communicate with you via your email address. 

 <br/> 

• Sending email notifications. We use your personal data to send you the notifications you have requested. 

 <br/> 

• Security. We use your personal data to ensure the security of the website, including verifying compliance with our terms of use and monitoring private messages sent through our private messaging service. 

<br/> 

• Fraud prevention. We use your personal data to prevent and detect fraud and abuse to protect user safety. 

 <br/> 

• Personalization. We use your personal data to personalize our website for you. 

 <br/> 

• Resolving complaints and inquiries. We use your personal data to resolve complaints you submit about our website, and to respond to your inquiries. 

 <br/> 

• Enabling your use of the website. We use your personal data to enable you to use the services available on our website. 

<br/><br/> 
<strong>ON WHAT BASIS DO WE PROCESS YOUR DATA?</strong><br/><br/> 

In accordance with Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation – GDPR), we process your data:<br/> 

a) When processing is necessary for compliance with a legal obligation (Art. 6(1)(c) GDPR). The Controller processes your personal data, among others, based on:<br/> 
   a.) provisions on the provision of electronic services,<br/> 

b) When processing is necessary for the purposes of the legitimate interests pursued by the Controller (Art. 6(1)(f) GDPR),<br/> 

c) When processing is based on your consent (Art. 6(1)(a) GDPR). Consent to the processing of your personal data is voluntary. You have the right to withdraw your consent at any time. Withdrawal of consent does not affect the lawfulness of processing based on consent before its withdrawal. 

<br/><br/><strong> 

DO WE SHARE YOUR PERSONAL DATA?</strong><br/><br/> 

Your personal data is shared with entities affiliated with the Controller. They follow the same high standards of care regarding the security of your personal data. Sharing takes place for strictly defined purposes and in the manner described below:<br/><br/> 

We share your personal data with public authorities and entities performing public tasks or acting on behalf of public authorities, only to the extent and for the purposes arising from generally applicable law.<br/> 

We share your personal data with entities cooperating with the Controller.<br/> 

We share your personal data with entities performing tasks for the Controller, including software providers and postal operators.<br/> 

We share statistical information about our users with third parties; third parties are not able to identify any specific user based on this information.<br/><br/> 

 

<strong>DO WE TRANSFER YOUR DATA TO COUNTRIES OUTSIDE THE EUROPEAN ECONOMIC AREA?</strong> <br/> <br/> 

Most of the entities processing and storing personal data on our website are based in Poland and other countries of the European Economic Area (EEA). Outside the EEA, only the entity cooperating in providing statistical services for our website is based – Google Inc., which uses the Google Analytics tool and is headquartered in the USA. This entity is obliged to comply with the principles of the EU–US Privacy Shield framework, which regulates the collection, use, and storage of personal data of EU citizens – pursuant to Commission Implementing Decision (EU) 2016/1250 of 12 July 2016 on the adequacy of the protection provided by the EU–US Privacy Shield – as well as clauses adopted by the European Commission. <br/> <br/> 

 

<strong>HOW LONG DO WE PROCESS YOUR PERSONAL DATA?</strong> <br/> <br/> 

We will store your data for the period necessary to achieve the above purposes; not shorter than the period indicated in archival regulations or other applicable laws. We will also retain electronic documents containing personal data if: <br/> <br/> 

a) we believe the data may be relevant to any ongoing or future legal proceedings, 
 <br/> b) required by law, 
<br/> c) we believe the data may be relevant in establishing, exercising, or defending our rights. 

<br/> <br/> 

<strong>WHAT ARE YOUR RIGHTS REGARDING THE PROCESSING OF PERSONAL DATA?</strong> <br/> <br/> 

The processing of your personal data requires that we respect your rights. To ensure their fulfillment, we have designated a contact person, whom you can reach by sending an email to: spedytorszkolenia@gmail.com. <br/> 

You have the right to: <br/> <br/> 

Access your personal data. This allows you to obtain information on whether we process personal data concerning you, and, if so, to receive a copy of the data. It also allows you to verify whether we process your data lawfully.<br/> 

Rectify your personal data. If you find your data incomplete, inaccurate, or outdated, you may request correction. When fulfilling your request, we must verify the accuracy of the new data provided.<br/> 

Restrict the processing of your personal data. If you object to further processing, we must verify whether we still have overriding and legitimate grounds to continue processing your personal data.<br/> 

You may request a restriction of processing in the following cases: <br/> 
 ✓ When you contest the accuracy of your personal data, <br/> 
 ✓ When it appears our processing is not in compliance with applicable law, <br/> 
 ✓ When the data is needed by you to establish, exercise, or defend legal claims. <br/> 

Erase your personal data. We are obliged to delete your personal data without undue delay when:<br/> 
 ✓ Your data is no longer necessary for the purposes for which it was collected or otherwise processed,<br/> 
 ✓ You have exercised your right to object to processing,<br/> 
 ✓ You have withdrawn the consent on which the processing was based,<br/> 
 ✓ We processed your data unlawfully or are obliged to delete your personal data to comply with a legal obligation.<br/><br/> 

Please note that we may not always be obliged to delete your data, in particular when processing is necessary to fulfill a legal obligation. <br/> <br/> 

Object to the processing of your personal data if you believe that the processing affects your rights or freedoms. You may base the objection on your particular situation indicating that the processing of your personal data infringes your rights or freedoms. In certain specific cases, we may demonstrate that we have legitimate grounds for processing that override your rights and freedoms – especially in cases of ensuring website security and preventing fraud. In such cases, this right does not combine with the right to erasure.<br/> 

Data portability. If you wish to receive your personal data in a commonly used, machine-readable format or have it transmitted to a third party designated by you, you may exercise your right to data portability.<br/> 

Lodge a complaint. You have the right to lodge a complaint with the supervisory authority – the President of the Personal Data Protection Office (address: ul. Stawki 2, 00-193 Warsaw, Poland). While you have the right to complain, we would greatly appreciate it if you contacted us first so that we can address your concerns. Therefore, we encourage you to contact our Data Protection Officer. 

<br/><br/> 

<strong>HOW SECURE IS MY INFORMATION?</strong><br/><br/> 

✓ We strive to provide the highest level of security for website users; therefore, we continuously work on securing and protecting your personal data during transmission using specialist encryption protocols and dedicated software.<br/> 
 ✓ We regularly organize, maintain, and update physical, electronic, and procedural safeguards for personal data collection, storage, and disclosure. These measures ensure you have the highest level of protection for your personal data.<br/> 
 ✓ All information about you that we process is stored on appropriately encrypted and secured servers. The Controller regularly assesses network security and monitors internal regulations and procedures to protect data against possible negative consequences.<br/> 
 ✓ Even with the highest security standards and state-of-the-art technology, complete security of personal data transmitted via the Internet or public networks cannot be guaranteed. Therefore, there is a risk that unauthorized third parties may gain access to your personal data.<br/><br/> 

<strong> 

USE OF COOKIES</strong><br/><br/> 

What are Cookies? Cookies are data files, especially text files, stored on users’ end devices and sent by various websites. Cookies allow the recognition of your device and the proper display of the website according to your preferences. Cookies usually contain the name of the website they come from.<br/> 

<strong>Why do we use Cookies?</strong><br/><br/> 
 We use Cookies and other technologies (collectively referred to as “Cookies”) to recognize your browser or device, learn more about your interests, and provide essential features.<br/> 

In particular, we use Cookies to:<br/> 

Prevent fraudulent activity,<br/> 

Improve security,<br/> 

Reporting (measuring and analyzing service performance).<br/> 

<br/><strong>Types of Cookies we use:</strong><br/><br/> 

Session cookies – stored temporarily until the browser is closed.<br/> 

Persistent cookies – stored for a specified period or until you delete them.<br/><br/> 

<strong>Categories of Cookies used on the website:</strong><br/><br/> 

Necessary – enable the use of services available on the website (e.g., authentication cookies for services requiring login).<br/> 

Performance – collect information on how the website is used.<br/> 

Functional – remember selected settings and personalize your interface (e.g., language, region, font size, website appearance).<br/> 

Security – used to detect authentication abuses.<br/> 
<br/>
<strong>Recommended security measures:</strong><br/><br/> 
 Your device should have antivirus software with an up-to-date virus definition database, a secure and updated web browser, and a firewall enabled. Enabling anti-phishing filters is also recommended. Avoid opening suspicious attachments or clicking on unknown links. Use only trusted Wi-Fi networks.<br/><br/> 

<strong>Do Cookies contain personal data?</strong><br/><br/> 
 While Cookies do not in themselves constitute personal data, some stored information (e.g., preferences) may be treated as personal data. Personal data obtained via Cookies may be processed only to perform specific functions for the user as described above. Such data is encrypted to prevent unauthorized access.<br/> 
<br/><br/>
<strong>How do we ensure security?</strong><br/><br/> 
 We use storage and reading mechanisms for Cookies that prevent the retrieval of any confidential information from your device. It is impossible for viruses, trojans, or other malware to be transferred from our servers to your device via Cookies.<br/> 
<br/><br/>
<strong>Deleting Cookies and changing preferences:</strong><br/><br/> 
 The website’s right to store and access Cookies is based on your consent, expressed when configuring your browser or upon visiting the website. You can adjust your settings at any time. Most browsers allow default storage of Cookies, but you can block them at any time. Links with detailed instructions for various browsers are provided:<br/> 

Google Chrome – https://support.google.com/chrome/answer/95647?hl=en <br/> 

Mozilla Firefox – https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored <br/> 

Opera – https://help.opera.com/en/latest/web-preferences/#cookies <br/> 

Edge – https://support.microsoft.com/en-us/help/10607/microsoft-edge-view-delete-browser-history <br/> 

Safari – https://support.apple.com/en/guide/safari/sfri11471/mac <br/> 

Internet Explorer – http://windows.microsoft.com/en-us/internet-explorer/delete-manage-cookies#ie=ie-11 <br/> 
<br/><br/>
If you disable all Cookies, neither we nor third parties will send Cookies to your browser. However, you may need to manually adjust preferences each time you visit the site, and some functions may not work. To exercise your right to object under the GDPR, you must log out of all devices and delete Cookies from them. The update process may take up to 48 hours.<br/> 

 
<br/><br/>
<strong> 

CHANGES TO THE PRIVACY POLICY</strong><br/><br/> 

The Privacy Policy may be changed or updated, particularly when a change in law requires us to do so. All significant changes will be posted on this page, and we will additionally inform you via our website.<br/><br/> 

 

<strong>FINAL PROVISIONS</strong><br/><br/> 

Additional information about the processing of your personal data, including answers to questions about the scope of this Privacy Policy, can be obtained by contacting the Controller or the Data Protection Officer. 

<br/><br/> 

<strong>Company Details</strong><br/><br/> 

LOGI DIGITAL KRZYSZTOF WIŚNIEWSKI<br/> 
 UL. DERDOWSKIEGO 9/17<br/> 
 85-795 BYDGOSZCZ<br/> 
 NIP: 5541012980<br/> 
 Register Number (REGON): 090412534<br/> 

 

 

 

 

 

 

 

 

 

 

 

 

 

 

 

 

 

 

 
            </p>
        </div>
        <Footer/>
        </div>
    )
}

export default TermsAndConditions
